import React from 'react';
import { Link } from 'react-router-dom';
import GymManagement from '../components/GymManagement';

const GymManagementPage = () => {
  return (
    <div className="min-h-screen">
      {/* Navigation Header */}
      <div className="bg-black/80 backdrop-blur-sm text-white p-3 sm:p-4 fixed w-full top-0 z-50">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center max-w-7xl mx-auto gap-2 sm:gap-0">
          <div className="flex items-center space-x-2 sm:space-x-4 w-full sm:w-auto">
            <Link
              to="/"
              className="bg-pink-600 hover:bg-pink-700 text-white px-3 sm:px-4 py-2 rounded-lg transition-colors flex items-center space-x-2 text-sm sm:text-base whitespace-nowrap"
            >
              {/* <FaArrowLeft /> */}
              {/* <span className="hidden xs:inline">Back to Portfolio</span>. */}
              {/* <span className="xs:hidden">Back</span> */}
            </Link>
            <h1 className="text-sm sm:text-lg lg:text-xl font-bold line-clamp-2 sm:line-clamp-1">Rugged Fitness Coach Sabari - Gym Management System</h1>
          </div>
          <div className="text-xs sm:text-sm text-gray-300 w-full sm:w-auto text-left sm:text-right">
            Developed by Sabarisan P
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="pt-24 sm:pt-20">
        <GymManagement />
      </div>
    </div>
  );
};

export default GymManagementPage;